import { PageHeader } from '@/components/PageHeader';
import { SmartRecommendationsEngine } from '@/components/SmartRecommendationsEngine';

export default function SmartRecommendations() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Smart Recommendations"
        description="AI-powered recommendations to optimize your bill processing workflow"
      />
      <SmartRecommendationsEngine />
    </div>
  );
}